import { makeStyles } from '@material-ui/core';
import { ReactComponent as ReportsIcon } from '../icons/reports2.svg';
import Modal from './Modal';

interface TermsAndConditionsProps {
    open: boolean;
    onClose: () => void;
    content?: string;
    extension?: string;
    version?: number;
}

const TermsAndConditions = ({
    open,
    onClose,
    content,
    extension,
    version,
}: TermsAndConditionsProps) => {
    const classes = useStyles();

    const handleClose = () => {
        onClose();
    };

    return (
        <Modal
            open={open}
            title="Terms and Conditions"
            onClose={handleClose}
            icon={<ReportsIcon />}
            maxWidth="md"
        >
            <div className={classes.versionWrapper}>
                <p className={classes.version}>Version: {version}</p>
            </div>
            <div className={classes.content}>{content}</div>
        </Modal>
    );
};

const useStyles = makeStyles((theme) => ({
    versionWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
        margin: 0,
        padding: 0,
        marginBottom: '-30px',
    },
    version: {
        color: theme.palette.gray.dark,
        margin: 0,
        padding: 0,
    },
    content: {
        whiteSpace: 'pre-line',
        textAlign: 'justify',
    },
}));

export default TermsAndConditions;
